"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRebuildSegmentMutation = exports.useGetSegmentsQuery = exports.useGetSegmentQuery = exports.useGetSegmentOverridesQuery = exports.useGetSegmentMembersQuery = exports.useGetSegmentHistoryQuery = exports.useGetSegmentFieldsQuery = exports.useGetSegmentActionRunsQuery = exports.useGetPlayerSegmentsQuery = exports.useAddSegmentOverrideMutation = exports.useAddSegmentActionMutation = exports.useGetRewardTrackTransactionListQuery = exports.useGetRewardTracksQuery = exports.useGetRewardTrackQuery = exports.useGetPlayerStatisticRanksQuery = exports.useGetPlayerProfileQuery = exports.useGetLeaderboardVersionsQuery = exports.useGetLeaderboardQuery = exports.useGetEventTypesQuery = exports.useGetEventTypeQuery = exports.useGetEconomyTransactionListQuery = exports.useGetEarnConfigsQuery = exports.useGetEarnConfigQuery = exports.useGetCurrencyQuery = exports.useGetCurrenciesQuery = exports.useGetChallengeTransactionListQuery = exports.useGetChallengesQuery = exports.useGetChallengeQuery = exports.useGetChallengeInventoryQuery = exports.useGetAppQuery = exports.useDeleteStatisticMutation = exports.useDeleteSegmentMutation = exports.useDeleteRewardTrackMutation = exports.useDeleteEarnConfigMutation = exports.useDeleteCurrencyMutation = exports.useDeleteChallengeMutation = exports.useUpdateItemMutation = exports.useIssueItemRevokeMutation = exports.useIssueItemConsumeMutation = exports.useIssueItemGrantMutation = exports.useGetItemTransactionsQuery = exports.useGetItemsQuery = exports.useGetItemQuery = exports.useGetItemInventoryQuery = exports.useGetItemHoldersQuery = exports.useDeleteItemMutation = exports.useCreateItemMutation = exports.useCreateStatisticMutation = exports.useCreateSegmentMutation = exports.letsachieveApi = void 0;
exports.useUpdateStatisticMutation = exports.useUpdateSegmentMutation = exports.useUpdateAppMutation = exports.useSaveRewardTrackMutation = exports.useSaveEventTypeMutation = exports.useSaveEarnConfigMutation = exports.useSaveCurrencyMutation = exports.useSaveChallengeSegmentMutation = exports.useSaveChallengeMutation = exports.useResetStatisticMutation = exports.useListAuditLogsQuery = exports.useLazyGetCurrencyQuery = exports.useIssueWalletCreditMutation = exports.useIssueStatisticGrantMutation = exports.useGetStatisticTransactionsQuery = exports.useGetStatisticSummaryQuery = exports.useGetStatisticsQuery = exports.useGetStatisticQuery = exports.useRetrySegmentActionRunMutation = exports.useRemoveSegmentOverrideMutation = exports.useRemoveSegmentActionMutation = exports.useRemoveChallengeSegmentMutation = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var base_query_1 = require("./base_query");
var withCount = function (response) {
    var _a, _b, _c, _d, _e;
    return ({
        items: (_a = response === null || response === void 0 ? void 0 : response.content) !== null && _a !== void 0 ? _a : [],
        count: (_e = (_c = (_b = response === null || response === void 0 ? void 0 : response.pagination) === null || _b === void 0 ? void 0 : _b.count) !== null && _c !== void 0 ? _c : (_d = response === null || response === void 0 ? void 0 : response.content) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0,
    });
};
var segmentMembershipTags = function (segmentId) { return [
    "Segment",
    "PlayerSegment",
    "SegmentHistory",
    "SegmentActionRun",
    { type: "Segment", id: segmentId },
    { type: "SegmentMember", id: segmentId },
    { type: "SegmentOverride", id: segmentId },
]; };
var itemHoldingTags = function (userId, itemId) { return [
    "ItemTransaction",
    { type: "Item", id: itemId },
    { type: "ItemHolder", id: itemId },
    { type: "ItemInventory", id: userId },
    { type: "AuditLog", id: userId },
    { type: "PlayerProfile", id: userId },
]; };
var letsachieveApi = (0, react_1.createApi)({
    reducerPath: "letsachieveApi",
    baseQuery: (0, base_query_1.authorisedBaseQuery)((_a = process.env.LETS_ACHIEVE_URL) !== null && _a !== void 0 ? _a : ""),
    refetchOnMountOrArgChange: 30,
    refetchOnFocus: true,
    tagTypes: [
        "App",
        "AuditLog",
        "Challenge",
        "ChallengeInventory",
        "Currency",
        "EarnConfig",
        "EventType",
        "Item",
        "ItemHolder",
        "ItemInventory",
        "ItemTransaction",
        "Leaderboard",
        "LeaderboardVersion",
        "PlayerProfile",
        "PlayerStatisticRank",
        "RewardTrack",
        "PlayerSegment",
        "Segment",
        "SegmentActionRun",
        "SegmentField",
        "SegmentHistory",
        "SegmentMember",
        "SegmentOverride",
        "Statistic",
        "StatisticSummary",
        "StatisticTransaction",
        "Transaction",
    ],
    endpoints: function (builder) { return ({
        getItems: builder.query({
            query: function (args) { return ({ url: "items", params: args }); },
            transformResponse: (withCount),
            providesTags: ["Item"],
        }),
        getItem: builder.query({
            query: function (itemId) { return ({ url: "items/".concat(itemId) }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, itemId) { return [{ type: "Item", id: itemId }]; },
        }),
        createItem: builder.mutation({
            query: function (body) { return ({ url: "items", method: "POST", body: body }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: ["Item"],
        }),
        updateItem: builder.mutation({
            query: function (_a) {
                var item_id = _a.item_id, body = _a.body;
                return ({ url: "items/".concat(item_id), method: "PUT", body: body });
            },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var item_id = _a.item_id;
                return ["Item", "ItemInventory", { type: "Item", id: item_id }];
            },
        }),
        deleteItem: builder.mutation({
            query: function (itemId) { return ({ url: "items/".concat(itemId), method: "DELETE" }); },
            invalidatesTags: ["Item", "ItemInventory"],
        }),
        getItemHolders: builder.query({
            query: function (_a) {
                var item_id = _a.item_id, page = _a.page, size = _a.size;
                return ({ url: "items/".concat(item_id, "/holders"), params: { page: page, size: size } });
            },
            transformResponse: (withCount),
            providesTags: function (_result, _error, _a) {
                var item_id = _a.item_id;
                return [{ type: "ItemHolder", id: item_id }];
            },
        }),
        getItemInventory: builder.query({
            query: function (userId) { return ({ url: "items/inventory", params: { user_id: userId } }); },
            transformResponse: function (response) { var _a; return (_a = (0, base_query_1.unwrapEnvelope)(response)) !== null && _a !== void 0 ? _a : []; },
            providesTags: function (_result, _error, userId) { return [{ type: "ItemInventory", id: userId }]; },
        }),
        getItemTransactions: builder.query({
            query: function (args) { return ({ url: "items/transactions", params: args }); },
            transformResponse: (withCount),
            providesTags: ["ItemTransaction"],
        }),
        getChallengeInventory: builder.query({
            query: function (args) { return ({ url: "challenges/inventory", params: args }); },
            transformResponse: function (response) { var _a; return (_a = (0, base_query_1.unwrapEnvelope)(response)) !== null && _a !== void 0 ? _a : []; },
            providesTags: function (_result, _error, args) { return [{ type: "ChallengeInventory", id: args.user_id }]; },
        }),
        getPlayerProfile: builder.query({
            query: function (userId) { return ({ url: "player/profile/".concat(userId) }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, userId) { return [{ type: "PlayerProfile", id: userId }]; },
        }),
        // the service uses SuccessPaginationResponse, which puts the array in content with pagination as a sibling, not under content.data
        getRewardTracks: builder.query({
            query: function (args) { return ({ url: "reward-tracks", params: args }); },
            transformResponse: (withCount),
            providesTags: ["RewardTrack"],
        }),
        getRewardTrack: builder.query({
            query: function (rewardTrackId) { return ({ url: "reward-tracks/".concat(rewardTrackId) }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, rewardTrackId) { return [{ type: "RewardTrack", id: rewardTrackId }]; },
        }),
        saveRewardTrack: builder.mutation({
            query: function (body) { return ({ url: "reward-tracks/".concat(body._id), method: "PUT", body: body }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: ["RewardTrack"],
        }),
        deleteRewardTrack: builder.mutation({
            query: function (rewardTrackId) { return ({ url: "reward-tracks/".concat(rewardTrackId), method: "DELETE" }); },
            invalidatesTags: ["RewardTrack"],
        }),
        getChallenges: builder.query({
            query: function (args) { return ({ url: "challenges", params: args }); },
            transformResponse: (withCount),
            providesTags: ["Challenge"],
        }),
        getChallenge: builder.query({
            query: function (challengeId) { return ({ url: "challenges/".concat(challengeId) }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, challengeId) { return [{ type: "Challenge", id: challengeId }]; },
        }),
        saveChallenge: builder.mutation({
            query: function (body) { return ({ url: "challenges", method: "POST", body: body }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: ["Challenge"],
        }),
        deleteChallenge: builder.mutation({
            query: function (challengeId) { return ({ url: "challenges/".concat(challengeId), method: "DELETE" }); },
            invalidatesTags: ["Challenge"],
        }),
        saveChallengeSegment: builder.mutation({
            query: function (_a) {
                var challenge_id = _a.challenge_id, segment_id = _a.segment_id, run_for_current_members = _a.run_for_current_members;
                return ({
                    url: "challenges/".concat(challenge_id, "/segments/").concat(segment_id),
                    method: "POST",
                    body: { run_for_current_members: Boolean(run_for_current_members) },
                });
            },
            invalidatesTags: function (_result, _error, _a) {
                var challenge_id = _a.challenge_id, segment_id = _a.segment_id;
                return [
                    "Segment",
                    "SegmentActionRun",
                    { type: "Challenge", id: challenge_id },
                    { type: "Segment", id: segment_id },
                ];
            },
        }),
        removeChallengeSegment: builder.mutation({
            query: function (_a) {
                var challenge_id = _a.challenge_id, segment_id = _a.segment_id;
                return ({ url: "challenges/".concat(challenge_id, "/segments/").concat(segment_id), method: "DELETE" });
            },
            invalidatesTags: function (_result, _error, _a) {
                var challenge_id = _a.challenge_id, segment_id = _a.segment_id;
                return ["Segment", { type: "Challenge", id: challenge_id }, { type: "Segment", id: segment_id }];
            },
        }),
        getCurrencies: builder.query({
            query: function (args) { return ({ url: "economy/currencies", params: args }); },
            transformResponse: (withCount),
            providesTags: ["Currency"],
        }),
        getCurrency: builder.query({
            query: function (currencyId) { return ({ url: "economy/currencies/".concat(currencyId) }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, currencyId) { return [{ type: "Currency", id: currencyId }]; },
        }),
        saveCurrency: builder.mutation({
            query: function (body) { return ({ url: "economy/currencies", method: "POST", body: body }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: ["Currency"],
        }),
        deleteCurrency: builder.mutation({
            query: function (currencyId) { return ({ url: "economy/currencies/".concat(currencyId), method: "DELETE" }); },
            invalidatesTags: ["Currency"],
        }),
        getEarnConfigs: builder.query({
            query: function (args) { return ({ url: "economy/earn-configs", params: args }); },
            transformResponse: (withCount),
            providesTags: ["EarnConfig"],
        }),
        getEarnConfig: builder.query({
            query: function (earnConfigId) { return ({ url: "economy/earn-configs/".concat(earnConfigId) }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, earnConfigId) { return [{ type: "EarnConfig", id: earnConfigId }]; },
        }),
        saveEarnConfig: builder.mutation({
            query: function (body) { return ({ url: "economy/earn-configs", method: "POST", body: body }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: ["EarnConfig"],
        }),
        deleteEarnConfig: builder.mutation({
            query: function (earnConfigId) { return ({ url: "economy/earn-configs/".concat(earnConfigId), method: "DELETE" }); },
            invalidatesTags: ["EarnConfig"],
        }),
        // one app config per client, so it needs no argument and a single cache entry
        getApp: builder.query({
            query: function () { return ({ url: "app" }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: ["App"],
        }),
        updateApp: builder.mutation({
            query: function (body) { return ({ url: "app", method: "PUT", body: body }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: ["App"],
        }),
        getEventTypes: builder.query({
            query: function (args) { return ({ url: "events/types", params: args }); },
            transformResponse: (withCount),
            providesTags: ["EventType"],
        }),
        // an event type is keyed by its event_type string rather than an id
        getEventType: builder.query({
            query: function (eventType) { return ({ url: "events/types/".concat(eventType) }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, eventType) { return [{ type: "EventType", id: eventType }]; },
        }),
        saveEventType: builder.mutation({
            query: function (body) { return ({ url: "events/types", method: "POST", body: body }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: ["EventType"],
        }),
        getStatistics: builder.query({
            query: function (args) { return ({ url: "statistics", params: args }); },
            transformResponse: (withCount),
            providesTags: ["Statistic"],
        }),
        getStatistic: builder.query({
            query: function (statisticId) { return ({ url: "statistics/".concat(statisticId) }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, statisticId) { return [{ type: "Statistic", id: statisticId }]; },
        }),
        createStatistic: builder.mutation({
            query: function (body) { return ({ url: "statistics", method: "POST", body: body }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: ["Statistic"],
        }),
        updateStatistic: builder.mutation({
            query: function (_a) {
                var statistic_id = _a.statistic_id, body = _a.body;
                return ({ url: "statistics/".concat(statistic_id), method: "PUT", body: body });
            },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var statistic_id = _a.statistic_id;
                return ["Statistic", { type: "Leaderboard", id: statistic_id }];
            },
        }),
        deleteStatistic: builder.mutation({
            query: function (statisticId) { return ({ url: "statistics/".concat(statisticId), method: "DELETE" }); },
            invalidatesTags: ["Statistic"],
        }),
        getStatisticSummary: builder.query({
            query: function (statisticId) { return ({ url: "statistics/".concat(statisticId, "/summary") }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, statisticId) { return [{ type: "StatisticSummary", id: statisticId }]; },
        }),
        getStatisticTransactions: builder.query({
            query: function (args) { return ({ url: "statistics/transactions", params: args }); },
            transformResponse: (withCount),
            providesTags: ["StatisticTransaction"],
        }),
        getLeaderboard: builder.query({
            query: function (_a) {
                var statistic_id = _a.statistic_id, version = _a.version, page = _a.page, size = _a.size;
                return ({ url: "statistics/".concat(statistic_id, "/leaderboard"), params: { version: version, page: page, size: size } });
            },
            transformResponse: function (response) {
                var _a, _b, _c;
                var leaderboard = (0, base_query_1.unwrapEnvelope)(response);
                var entries = (_a = leaderboard === null || leaderboard === void 0 ? void 0 : leaderboard.entries) !== null && _a !== void 0 ? _a : [];
                return __assign(__assign({}, leaderboard), { entries: entries, count: (_c = (_b = response === null || response === void 0 ? void 0 : response.pagination) === null || _b === void 0 ? void 0 : _b.count) !== null && _c !== void 0 ? _c : entries.length });
            },
            providesTags: function (_result, _error, _a) {
                var statistic_id = _a.statistic_id;
                return [{ type: "Leaderboard", id: statistic_id }];
            },
        }),
        getLeaderboardVersions: builder.query({
            query: function (_a) {
                var statistic_id = _a.statistic_id, page = _a.page, size = _a.size;
                return ({ url: "statistics/".concat(statistic_id, "/leaderboard/versions"), params: { page: page, size: size } });
            },
            transformResponse: (withCount),
            providesTags: function (_result, _error, _a) {
                var statistic_id = _a.statistic_id;
                return [{ type: "LeaderboardVersion", id: statistic_id }];
            },
        }),
        getPlayerStatisticRanks: builder.query({
            query: function (userId) { return ({ url: "statistics/ranks", params: { user_id: userId } }); },
            transformResponse: function (response) { var _a; return (_a = (0, base_query_1.unwrapEnvelope)(response)) !== null && _a !== void 0 ? _a : []; },
            providesTags: function (_result, _error, userId) { return [{ type: "PlayerStatisticRank", id: userId }]; },
        }),
        resetStatistic: builder.mutation({
            query: function (statisticId) { return ({ url: "statistics/".concat(statisticId, "/reset"), method: "POST" }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, statisticId) { return [
                "Statistic",
                "StatisticTransaction",
                "PlayerStatisticRank",
                "PlayerProfile",
                { type: "Leaderboard", id: statisticId },
                { type: "LeaderboardVersion", id: statisticId },
                { type: "StatisticSummary", id: statisticId },
            ]; },
        }),
        getSegments: builder.query({
            query: function (args) { return ({ url: "segments", params: args }); },
            transformResponse: (withCount),
            providesTags: ["Segment"],
        }),
        getSegment: builder.query({
            query: function (segmentId) { return ({ url: "segments/".concat(segmentId) }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, segmentId) { return [{ type: "Segment", id: segmentId }]; },
        }),
        getSegmentFields: builder.query({
            query: function () { return ({ url: "segments/fields" }); },
            transformResponse: function (response) { var _a; return (_a = (0, base_query_1.unwrapEnvelope)(response)) !== null && _a !== void 0 ? _a : []; },
            providesTags: ["SegmentField"],
        }),
        createSegment: builder.mutation({
            query: function (body) { return ({ url: "segments", method: "POST", body: body }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: ["Segment", "PlayerSegment", "SegmentHistory"],
        }),
        updateSegment: builder.mutation({
            query: function (_a) {
                var segment_id = _a.segment_id, body = _a.body;
                return ({ url: "segments/".concat(segment_id), method: "PUT", body: body });
            },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var segment_id = _a.segment_id;
                return segmentMembershipTags(segment_id);
            },
        }),
        deleteSegment: builder.mutation({
            query: function (segmentId) { return ({ url: "segments/".concat(segmentId), method: "DELETE" }); },
            invalidatesTags: ["Segment", "PlayerSegment", "SegmentHistory", "Challenge"],
        }),
        rebuildSegment: builder.mutation({
            query: function (_a) {
                var segment_id = _a.segment_id, build_mode = _a.build_mode;
                return ({ url: "segments/".concat(segment_id, "/rebuild"), method: "POST", body: { build_mode: build_mode } });
            },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var segment_id = _a.segment_id;
                return segmentMembershipTags(segment_id);
            },
        }),
        addSegmentAction: builder.mutation({
            query: function (_a) {
                var segment_id = _a.segment_id, body = _a.body;
                return ({ url: "segments/".concat(segment_id, "/actions"), method: "POST", body: body });
            },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var segment_id = _a.segment_id;
                return ["Segment", "SegmentActionRun", "Challenge", { type: "Segment", id: segment_id }];
            },
        }),
        removeSegmentAction: builder.mutation({
            query: function (_a) {
                var segment_id = _a.segment_id, action_id = _a.action_id;
                return ({ url: "segments/".concat(segment_id, "/actions/").concat(action_id), method: "DELETE" });
            },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var segment_id = _a.segment_id;
                return ["Segment", "Challenge", { type: "Segment", id: segment_id }];
            },
        }),
        getSegmentMembers: builder.query({
            query: function (_a) {
                var segment_id = _a.segment_id, page = _a.page, size = _a.size;
                return ({ url: "segments/".concat(segment_id, "/members"), params: { page: page, size: size } });
            },
            transformResponse: (withCount),
            providesTags: function (_result, _error, _a) {
                var segment_id = _a.segment_id;
                return [{ type: "SegmentMember", id: segment_id }];
            },
        }),
        getSegmentHistory: builder.query({
            query: function (args) { return ({ url: "segments/history", params: args }); },
            transformResponse: (withCount),
            providesTags: ["SegmentHistory"],
        }),
        getSegmentOverrides: builder.query({
            query: function (_a) {
                var segment_id = _a.segment_id, page = _a.page, size = _a.size;
                return ({ url: "segments/".concat(segment_id, "/overrides"), params: { page: page, size: size } });
            },
            transformResponse: (withCount),
            providesTags: function (_result, _error, _a) {
                var segment_id = _a.segment_id;
                return [{ type: "SegmentOverride", id: segment_id }];
            },
        }),
        addSegmentOverride: builder.mutation({
            query: function (_a) {
                var segment_id = _a.segment_id, user_id = _a.user_id, kind = _a.kind;
                return ({ url: "segments/".concat(segment_id, "/overrides"), method: "POST", body: { user_id: user_id, kind: kind } });
            },
            invalidatesTags: function (_result, _error, _a) {
                var segment_id = _a.segment_id;
                return segmentMembershipTags(segment_id);
            },
        }),
        removeSegmentOverride: builder.mutation({
            query: function (_a) {
                var segment_id = _a.segment_id, user_id = _a.user_id;
                return ({ url: "segments/".concat(segment_id, "/overrides/").concat(user_id), method: "DELETE" });
            },
            invalidatesTags: function (_result, _error, _a) {
                var segment_id = _a.segment_id;
                return segmentMembershipTags(segment_id);
            },
        }),
        getSegmentActionRuns: builder.query({
            query: function (args) { return ({ url: "segments/action-runs", params: args }); },
            transformResponse: (withCount),
            providesTags: ["SegmentActionRun"],
        }),
        retrySegmentActionRun: builder.mutation({
            query: function (runId) { return ({ url: "segments/action-runs/".concat(runId, "/retry"), method: "POST" }); },
            invalidatesTags: ["SegmentActionRun"],
        }),
        getPlayerSegments: builder.query({
            query: function (userId) { return ({ url: "segments/players/".concat(userId) }); },
            transformResponse: function (response) { var _a; return (_a = (0, base_query_1.unwrapEnvelope)(response)) !== null && _a !== void 0 ? _a : []; },
            providesTags: ["PlayerSegment"],
        }),
        // the transaction lists need the total, which arrives beside content rather than inside it
        getChallengeTransactionList: builder.query({
            query: function (args) { return ({ url: "transactions/challenges", params: args }); },
            transformResponse: (withCount),
            providesTags: ["Transaction"],
        }),
        getEconomyTransactionList: builder.query({
            query: function (args) { return ({ url: "transactions/economy", params: args }); },
            transformResponse: (withCount),
            providesTags: ["Transaction"],
        }),
        getRewardTrackTransactionList: builder.query({
            query: function (args) { return ({ url: "transactions/reward-tracks", params: args }); },
            transformResponse: (withCount),
            providesTags: ["Transaction"],
        }),
        // the admin grant routes are guarded by the client user token: the client token is not accepted
        listAuditLogs: builder.query({
            query: function (args) { return ({ url: "admin/grants/audit", params: args }); },
            extraOptions: { token: base_query_1.userToken },
            transformResponse: function (response) { var _a; return (_a = (0, base_query_1.unwrapEnvelope)(response)) !== null && _a !== void 0 ? _a : []; },
            providesTags: function (_result, _error, args) { var _a; return [{ type: "AuditLog", id: (_a = args.user_id) !== null && _a !== void 0 ? _a : args.target_id }]; },
        }),
        issueWalletCredit: builder.mutation({
            query: function (body) { return ({ url: "admin/grants/wallet", method: "POST", body: body }); },
            extraOptions: { token: base_query_1.userToken },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var user_id = _a.user_id;
                return [{ type: "AuditLog", id: user_id }];
            },
        }),
        issueStatisticGrant: builder.mutation({
            query: function (body) { return ({ url: "admin/grants/statistic", method: "POST", body: body }); },
            extraOptions: { token: base_query_1.userToken },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var user_id = _a.user_id;
                return [
                    "StatisticTransaction",
                    "Leaderboard",
                    "StatisticSummary",
                    { type: "AuditLog", id: user_id },
                    { type: "PlayerProfile", id: user_id },
                    { type: "PlayerStatisticRank", id: user_id },
                ];
            },
        }),
        issueItemGrant: builder.mutation({
            query: function (body) { return ({ url: "admin/grants/items", method: "POST", body: body }); },
            extraOptions: { token: base_query_1.userToken },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var user_id = _a.user_id, item_id = _a.item_id;
                return itemHoldingTags(user_id, item_id);
            },
        }),
        issueItemRevoke: builder.mutation({
            query: function (body) { return ({ url: "admin/grants/items/revoke", method: "POST", body: body }); },
            extraOptions: { token: base_query_1.userToken },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var user_id = _a.user_id, item_id = _a.item_id;
                return itemHoldingTags(user_id, item_id);
            },
        }),
        issueItemConsume: builder.mutation({
            query: function (body) { return ({ url: "admin/grants/items/consume", method: "POST", body: body }); },
            extraOptions: { token: base_query_1.userToken },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, _a) {
                var user_id = _a.user_id, item_id = _a.item_id;
                return itemHoldingTags(user_id, item_id);
            },
        }),
    }); },
});
exports.letsachieveApi = letsachieveApi;
var useGetItemsQuery = letsachieveApi.useGetItemsQuery, useGetItemQuery = letsachieveApi.useGetItemQuery, useCreateItemMutation = letsachieveApi.useCreateItemMutation, useUpdateItemMutation = letsachieveApi.useUpdateItemMutation, useDeleteItemMutation = letsachieveApi.useDeleteItemMutation, useGetItemHoldersQuery = letsachieveApi.useGetItemHoldersQuery, useGetItemInventoryQuery = letsachieveApi.useGetItemInventoryQuery, useGetItemTransactionsQuery = letsachieveApi.useGetItemTransactionsQuery, useIssueItemGrantMutation = letsachieveApi.useIssueItemGrantMutation, useIssueItemConsumeMutation = letsachieveApi.useIssueItemConsumeMutation, useIssueItemRevokeMutation = letsachieveApi.useIssueItemRevokeMutation, useGetChallengeInventoryQuery = letsachieveApi.useGetChallengeInventoryQuery, useGetPlayerProfileQuery = letsachieveApi.useGetPlayerProfileQuery, useGetRewardTracksQuery = letsachieveApi.useGetRewardTracksQuery, useGetRewardTrackQuery = letsachieveApi.useGetRewardTrackQuery, useSaveRewardTrackMutation = letsachieveApi.useSaveRewardTrackMutation, useDeleteRewardTrackMutation = letsachieveApi.useDeleteRewardTrackMutation, useGetChallengesQuery = letsachieveApi.useGetChallengesQuery, useGetChallengeQuery = letsachieveApi.useGetChallengeQuery, useSaveChallengeMutation = letsachieveApi.useSaveChallengeMutation, useDeleteChallengeMutation = letsachieveApi.useDeleteChallengeMutation, useSaveChallengeSegmentMutation = letsachieveApi.useSaveChallengeSegmentMutation, useGetCurrenciesQuery = letsachieveApi.useGetCurrenciesQuery, useGetCurrencyQuery = letsachieveApi.useGetCurrencyQuery, useLazyGetCurrencyQuery = letsachieveApi.useLazyGetCurrencyQuery, useSaveCurrencyMutation = letsachieveApi.useSaveCurrencyMutation, useDeleteCurrencyMutation = letsachieveApi.useDeleteCurrencyMutation, useGetEarnConfigsQuery = letsachieveApi.useGetEarnConfigsQuery, useGetEarnConfigQuery = letsachieveApi.useGetEarnConfigQuery, useSaveEarnConfigMutation = letsachieveApi.useSaveEarnConfigMutation, useDeleteEarnConfigMutation = letsachieveApi.useDeleteEarnConfigMutation, useGetStatisticsQuery = letsachieveApi.useGetStatisticsQuery, useGetStatisticQuery = letsachieveApi.useGetStatisticQuery, useCreateStatisticMutation = letsachieveApi.useCreateStatisticMutation, useUpdateStatisticMutation = letsachieveApi.useUpdateStatisticMutation, useDeleteStatisticMutation = letsachieveApi.useDeleteStatisticMutation, useGetStatisticSummaryQuery = letsachieveApi.useGetStatisticSummaryQuery, useGetStatisticTransactionsQuery = letsachieveApi.useGetStatisticTransactionsQuery, useGetLeaderboardQuery = letsachieveApi.useGetLeaderboardQuery, useGetLeaderboardVersionsQuery = letsachieveApi.useGetLeaderboardVersionsQuery, useGetPlayerStatisticRanksQuery = letsachieveApi.useGetPlayerStatisticRanksQuery, useResetStatisticMutation = letsachieveApi.useResetStatisticMutation, useGetAppQuery = letsachieveApi.useGetAppQuery, useUpdateAppMutation = letsachieveApi.useUpdateAppMutation, useGetEventTypesQuery = letsachieveApi.useGetEventTypesQuery, useGetEventTypeQuery = letsachieveApi.useGetEventTypeQuery, useSaveEventTypeMutation = letsachieveApi.useSaveEventTypeMutation, useGetSegmentsQuery = letsachieveApi.useGetSegmentsQuery, useGetSegmentQuery = letsachieveApi.useGetSegmentQuery, useGetSegmentFieldsQuery = letsachieveApi.useGetSegmentFieldsQuery, useCreateSegmentMutation = letsachieveApi.useCreateSegmentMutation, useUpdateSegmentMutation = letsachieveApi.useUpdateSegmentMutation, useDeleteSegmentMutation = letsachieveApi.useDeleteSegmentMutation, useRebuildSegmentMutation = letsachieveApi.useRebuildSegmentMutation, useAddSegmentActionMutation = letsachieveApi.useAddSegmentActionMutation, useRemoveSegmentActionMutation = letsachieveApi.useRemoveSegmentActionMutation, useGetSegmentMembersQuery = letsachieveApi.useGetSegmentMembersQuery, useGetSegmentHistoryQuery = letsachieveApi.useGetSegmentHistoryQuery, useGetSegmentOverridesQuery = letsachieveApi.useGetSegmentOverridesQuery, useAddSegmentOverrideMutation = letsachieveApi.useAddSegmentOverrideMutation, useRemoveSegmentOverrideMutation = letsachieveApi.useRemoveSegmentOverrideMutation, useGetSegmentActionRunsQuery = letsachieveApi.useGetSegmentActionRunsQuery, useRetrySegmentActionRunMutation = letsachieveApi.useRetrySegmentActionRunMutation, useGetPlayerSegmentsQuery = letsachieveApi.useGetPlayerSegmentsQuery, useRemoveChallengeSegmentMutation = letsachieveApi.useRemoveChallengeSegmentMutation, useGetChallengeTransactionListQuery = letsachieveApi.useGetChallengeTransactionListQuery, useGetEconomyTransactionListQuery = letsachieveApi.useGetEconomyTransactionListQuery, useGetRewardTrackTransactionListQuery = letsachieveApi.useGetRewardTrackTransactionListQuery, useListAuditLogsQuery = letsachieveApi.useListAuditLogsQuery, useIssueWalletCreditMutation = letsachieveApi.useIssueWalletCreditMutation, useIssueStatisticGrantMutation = letsachieveApi.useIssueStatisticGrantMutation;
exports.useGetItemsQuery = useGetItemsQuery;
exports.useGetItemQuery = useGetItemQuery;
exports.useCreateItemMutation = useCreateItemMutation;
exports.useUpdateItemMutation = useUpdateItemMutation;
exports.useDeleteItemMutation = useDeleteItemMutation;
exports.useGetItemHoldersQuery = useGetItemHoldersQuery;
exports.useGetItemInventoryQuery = useGetItemInventoryQuery;
exports.useGetItemTransactionsQuery = useGetItemTransactionsQuery;
exports.useIssueItemGrantMutation = useIssueItemGrantMutation;
exports.useIssueItemConsumeMutation = useIssueItemConsumeMutation;
exports.useIssueItemRevokeMutation = useIssueItemRevokeMutation;
exports.useGetChallengeInventoryQuery = useGetChallengeInventoryQuery;
exports.useGetPlayerProfileQuery = useGetPlayerProfileQuery;
exports.useGetRewardTracksQuery = useGetRewardTracksQuery;
exports.useGetRewardTrackQuery = useGetRewardTrackQuery;
exports.useSaveRewardTrackMutation = useSaveRewardTrackMutation;
exports.useDeleteRewardTrackMutation = useDeleteRewardTrackMutation;
exports.useGetChallengesQuery = useGetChallengesQuery;
exports.useGetChallengeQuery = useGetChallengeQuery;
exports.useSaveChallengeMutation = useSaveChallengeMutation;
exports.useDeleteChallengeMutation = useDeleteChallengeMutation;
exports.useSaveChallengeSegmentMutation = useSaveChallengeSegmentMutation;
exports.useGetCurrenciesQuery = useGetCurrenciesQuery;
exports.useGetCurrencyQuery = useGetCurrencyQuery;
exports.useLazyGetCurrencyQuery = useLazyGetCurrencyQuery;
exports.useSaveCurrencyMutation = useSaveCurrencyMutation;
exports.useDeleteCurrencyMutation = useDeleteCurrencyMutation;
exports.useGetEarnConfigsQuery = useGetEarnConfigsQuery;
exports.useGetEarnConfigQuery = useGetEarnConfigQuery;
exports.useSaveEarnConfigMutation = useSaveEarnConfigMutation;
exports.useDeleteEarnConfigMutation = useDeleteEarnConfigMutation;
exports.useGetStatisticsQuery = useGetStatisticsQuery;
exports.useGetStatisticQuery = useGetStatisticQuery;
exports.useCreateStatisticMutation = useCreateStatisticMutation;
exports.useUpdateStatisticMutation = useUpdateStatisticMutation;
exports.useDeleteStatisticMutation = useDeleteStatisticMutation;
exports.useGetStatisticSummaryQuery = useGetStatisticSummaryQuery;
exports.useGetStatisticTransactionsQuery = useGetStatisticTransactionsQuery;
exports.useGetLeaderboardQuery = useGetLeaderboardQuery;
exports.useGetLeaderboardVersionsQuery = useGetLeaderboardVersionsQuery;
exports.useGetPlayerStatisticRanksQuery = useGetPlayerStatisticRanksQuery;
exports.useResetStatisticMutation = useResetStatisticMutation;
exports.useGetAppQuery = useGetAppQuery;
exports.useUpdateAppMutation = useUpdateAppMutation;
exports.useGetEventTypesQuery = useGetEventTypesQuery;
exports.useGetEventTypeQuery = useGetEventTypeQuery;
exports.useSaveEventTypeMutation = useSaveEventTypeMutation;
exports.useGetSegmentsQuery = useGetSegmentsQuery;
exports.useGetSegmentQuery = useGetSegmentQuery;
exports.useGetSegmentFieldsQuery = useGetSegmentFieldsQuery;
exports.useCreateSegmentMutation = useCreateSegmentMutation;
exports.useUpdateSegmentMutation = useUpdateSegmentMutation;
exports.useDeleteSegmentMutation = useDeleteSegmentMutation;
exports.useRebuildSegmentMutation = useRebuildSegmentMutation;
exports.useAddSegmentActionMutation = useAddSegmentActionMutation;
exports.useRemoveSegmentActionMutation = useRemoveSegmentActionMutation;
exports.useGetSegmentMembersQuery = useGetSegmentMembersQuery;
exports.useGetSegmentHistoryQuery = useGetSegmentHistoryQuery;
exports.useGetSegmentOverridesQuery = useGetSegmentOverridesQuery;
exports.useAddSegmentOverrideMutation = useAddSegmentOverrideMutation;
exports.useRemoveSegmentOverrideMutation = useRemoveSegmentOverrideMutation;
exports.useGetSegmentActionRunsQuery = useGetSegmentActionRunsQuery;
exports.useRetrySegmentActionRunMutation = useRetrySegmentActionRunMutation;
exports.useGetPlayerSegmentsQuery = useGetPlayerSegmentsQuery;
exports.useRemoveChallengeSegmentMutation = useRemoveChallengeSegmentMutation;
exports.useGetChallengeTransactionListQuery = useGetChallengeTransactionListQuery;
exports.useGetEconomyTransactionListQuery = useGetEconomyTransactionListQuery;
exports.useGetRewardTrackTransactionListQuery = useGetRewardTrackTransactionListQuery;
exports.useListAuditLogsQuery = useListAuditLogsQuery;
exports.useIssueWalletCreditMutation = useIssueWalletCreditMutation;
exports.useIssueStatisticGrantMutation = useIssueStatisticGrantMutation;
